import { fetchWithHandling } from '../../utils/ApiUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';

// Login user
export async function loginUser(credentials) {
    return await fetchWithHandling(`${BASE_URL}auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
        credentials: 'include'
    });
}

// Logout user
export async function logoutUser() {
    return await fetchWithHandling(`${BASE_URL}auth/logout`, {
        method: 'POST',
        credentials: 'include'
    });
}

// Delete user
export async function deleteUser(userId) {
    return await fetchWithHandling(`${BASE_URL}auth/users/${userId}`, {
        method: 'DELETE',
        credentials: 'include'
    });
}

// Update user
export async function updateUser(id, updateData) {
    return await fetchWithHandling(`${BASE_URL}auth/users/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateData),
        credentials: 'include'
    });
}

// Update user password (dedicated endpoint)
export async function updateUserPassword(id, payload) {
    // payload should be { currentPassword?, newPassword }
    return await fetchWithHandling(`${BASE_URL}auth/users/${id}/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include'
    });
}

// Get all users
export async function getUsers() {
    return await fetchWithHandling(`${BASE_URL}auth/users`, {
        credentials: 'include'
    });
}

// Get single user
export async function getUser(userId) {
    return await fetchWithHandling(`${BASE_URL}auth/users/${userId}`, {
        credentials: 'include'
    });
}

// Create user
export async function createUser(userData) {
    return await fetchWithHandling(`${BASE_URL}auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
        credentials: 'include'
    });
}
